// Randomized id to make scrapper harder to target our layout
import config from 'Config';
import { hashFromString } from 'Lib/utils/hashUtils';

// Add some challenge for bots :)
const randomText = 'Nequeporroquisquamestquidoloremipsumquiadolorsitazmetconsecteturadipiscivelit';
const suffix = `${process.env.VERSION}x${config.idMaskKey}`;
// add all digits of app version as string index
const charIndex =
  process.env.VERSION.split('.')
    .map((segment) => +segment)
    .reduce((a, b) => (a + b) * 11 + 3) % randomText.length;

const prefix = randomText.charAt(charIndex) ?? 't';

export const contentId = `${prefix}${hashFromString(`content${suffix}`)}`;
export const modalManagerId = `${prefix}${hashFromString(`modal-manager${suffix}`)}`;
export const modalManagerCanvasId = `${prefix}${hashFromString(`modal-manager-canvas${suffix}`)}`;

export const matchesTabId = `${prefix}${hashFromString(`match-tab${suffix}`)}`;
export const messagesTabId = `${prefix}${hashFromString(`message-tab${suffix}`)}`;
export const archivedMatchesId = `${prefix}${hashFromString(`archived-matches-tab${suffix}`)}`;

export const archivedMatchListId = `${prefix}${hashFromString(`archived-match-list-${suffix}`)}`;
export const matchListNoMessagesId = `${prefix}${hashFromString(
  `match-list-no-messages${suffix}`
)}`;
export const matchListWithMessagesId = `${prefix}${hashFromString(
  `match-list-with-messages${suffix}`
)}`;
export const likesYouScrollerId = `${prefix}${hashFromString(`likes-you-scroller ${suffix}`)}`;
export const reportDialogSomeoneId = `${prefix}${hashFromString(`report-dialog-someone${suffix}`)}`;

export const chatInputId = `${prefix}${hashFromString(`chat-text-area${suffix}`)}`;

export const quickFiltersId = `${prefix}${hashFromString(`quick-filters${suffix}`)}`;

export const googleLoginButtonId = `${prefix}${hashFromString(`google-login-button${suffix}`)}`;
export const googleEmailAccountSettingsButtonId = `${prefix}${hashFromString(
  `google-email-account-settings-button${suffix}`
)}`;
export const googleEnterEmailButtonId = `${prefix}${hashFromString(
  `google-enter-email-button${suffix}`
)}`;

export const arkoseAnchorId = `${prefix}${hashFromString(`arokse-inline-anchor${suffix}`)}`;
